import type { FC } from 'react';
import React, { useState } from 'react';
import {
  IconButton, Menu, Badge,
  makeStyles, createStyles,
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import axios from 'axios';
import useSWR from 'swr';
import { useAuthContext } from '../../../auth/AuthContext';
import MessageSection from './MessageSection';
import type { Message } from './NotificationTypes';

const useStyles = makeStyles(() => createStyles({
  menu: {
    '& .MuiPaper-root': {
      minWidth: 300,
    },
    '& ul': {
      padding: 0,
    },
  },
  menuButton: {
    marginTop: 0,
  },
}));

const Messages: FC = (): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = useStyles();

  const { user } = useAuthContext();
  const userId = user?.userId;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetcher = (url: string, userIdParam: string) => axios.get<{ notifications:Message[] }>(url, {
    params: {
      userId: userIdParam,
    },
  })
    .then((response) => response.data);

  const { data, mutate } = useSWR((userId && userId !== '') ? ['/Notification/GetNotifications', userId] : null,
    (url, userIdParam) => fetcher(url, userIdParam), {
      refreshInterval: 60000,
      refreshWhenHidden: false,
      revalidateOnReconnect: false,
      refreshWhenOffline: false,
    });

  return (
    <>
      <IconButton onClick={handleClick}>
        <Badge overlap="rectangular" badgeContent={data?.notifications.filter((message) => !message.acknowledged).length || 0} color="error">
          <NotificationsIcon style={{ fill: 'white' }} />
        </Badge>
      </IconButton>
      <Menu
        id="customized-menu"
        className={classes.menu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={2}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MessageSection messages={data?.notifications || []} header="Notifications" notificationMutate={mutate} />
      </Menu>
    </>
  );
};

export default Messages;
